<template>
  <div class="form-element -nomargin">
    <div class="form-element__filtersearch" :class="{ '-secondary': isSecondary }">
      <div class="form-element__filtersearch__selectbox" v-if="!isSecondary">
        <div class="form-element__filtersearch__label" :data-exclude="true" @click="open()">
          {{ text }}
        </div>
        <div
          class="form-element__filtersearch__list"
          :class="{
            ' -noscroll': filteredList.length < 7
          }"
          v-click-outside="outside"
          v-if="isOpen"
        >
          <form-search v-model="search" />
          <div class="form-element__filtersearch__item" :class="{ '-selected': item.name == text }" v-for="item in filteredList" :key="`option-${item.id}`" @click="selectThis(item)">
            {{ item.name }}
          </div>
        </div>
      </div>
      <input class="form-element__filtersearch__search" type="search" ref="search" :placeholder="placeholder" autocomplete="off" v-model.trim="filtersearch" />
      <span class="form-element__filtersearch__cancel" @click="clear()"></span>
    </div>
  </div>
</template>

<script>
import { clickOutside } from '@/directives/'
export default {
  props: {
    value: {
      type: Object,
      default: null
    },
    list: {
      type: Array,
      default: null
    },
    placeholder: {
      type: String,
      default: 'Ara...'
    },
    isSecondary: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selected: null,
      isOpen: false,
      search: '',
      filtersearch: ''
    }
  },
  directives: {
    'click-outside': clickOutside
  },
  computed: {
    text: function () {
      return this.selected ? this.selected : 'Tümü'
    },
    filteredList() {
      return this.list.filter((item) => {
        return item.name.toLowerCase().includes(this.search.toLowerCase())
      })
    }
  },
  watch: {
    selected: function (val) {
      let data = {
        select: val || null,
        search: this.filtersearch
      }

      this.$emit('input', data)
    },
    filtersearch: function (val) {
      let data = {
        select: this.selected,
        search: val
      }

      this.$emit('input', data)
    }
  },
  created() {
    setTimeout(() => {
      this.$refs['search'].focus()
    }, 200)
  },
  methods: {
    selectThis: function (item) {
      let vm = this

      let isSameSelected = vm.selected == item.name

      vm.selected = isSameSelected ? null : item.name

      vm.isOpen = false
      vm.search = ''

      return
    },
    open: function () {
      let vm = this

      vm.isOpen = !vm.isOpen
    },
    outside: function () {
      this.isOpen = false
    },
    clear: function () {
      this.filtersearch = ''
    }
  }
}
</script>